module.exports = __webpack_public_path__ + "img/analyse-color@2x.9e119bba.png";